export default "__VITE_ASSET__Ctc60YCK__"